import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import colors from '../../theme/colors';

// data: [{ name, value, color? }]
export default function BarChart({ data, title, unit = 'kWh', height = 260 }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) return null;

    return {
      chart: { type: 'column', height },
      title: { text: title || '' },
      xAxis: {
        categories: data.map(d => d.name),
        crosshair: true,
        labels: { style: { color: colors.textMuted, fontSize: '11px' } },
      },
      yAxis: {
        title: { text: unit },
        min: 0,
      },
      series: [{
        name: unit,
        data: data.map((d, i) => ({
          y: d.value || 0,
          color: d.color || colors.series[i % colors.series.length],
        })),
        showInLegend: false,
      }],
      tooltip: {
        valueSuffix: ` ${unit}`,
        valueDecimals: 1,
      },
      plotOptions: {
        column: {
          borderRadius: 4,
          borderWidth: 0,
        },
      },
    };
  }, [data, title, unit, height]);

  if (!options) return null;
  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
